import tim from '../../tim';
var user = {
  namespaced: true,
  state: {
    currentUserProfile: {},
    isLogin: false,
    isSDKReady: false,
    // TIM SDK 是否 ready
    userID: localStorage.getItem('organizationInfo') && JSON.parse(localStorage.getItem('organizationInfo')).organizationCode || '',
    userSig: '',
    sdkAppID: process.env.VUE_APP_IM_SDK_ID,
    current: Date.now(),
    intervalID: 0
  },
  mutations: {
    startComputeCurrent: function startComputeCurrent(state) {
      state.intervalID = setInterval(function () {
        state.current = Date.now();
      }, 500);
    },
    updateCurrentUserProfile: function updateCurrentUserProfile(state, userProfile) {
      state.currentUserProfile = userProfile;
    },
    toggleIsLogin: function toggleIsLogin(state, isLogin) {
      state.isLogin = typeof isLogin === 'undefined' ? !state.isLogin : isLogin;
    },
    toggleIsSDKReady: function toggleIsSDKReady(state, isSDKReady) {
      state.isSDKReady = typeof isSDKReady === 'undefined' ? !state.isSDKReady : isSDKReady;
    },
    reset: function reset(state) {
      Object.assign(state, {
        currentUserProfile: {},
        isLogin: false,
        isSDKReady: false // TIM SDK 是否 ready

      });
    },
    SET_USER_ID: function SET_USER_ID(state, payload) {
      state.userID = payload;
    },
    GET_USER_INFO: function GET_USER_INFO(state, payload) {
      state.userID = payload.userID;
      state.userSig = payload.userSig;
      state.sdkAppID = payload.sdkAppID;
    }
  },
  actions: {
    login: function login(context, payload) {
      var userID = payload.userID,
          userSig = payload.userSig;
      tim.login({
        userID: userID,
        userSig: userSig
      }).then(function () {
        context.commit('toggleIsLogin', true);
        context.commit('startComputeCurrent'); // window.$message({ type: 'success', message: '登录成功' })
      }).catch(function (imError) {
        console.log('错误就是这里');

        if (imError.code === 2000) {
          window.$message.error(imError.message + ', 请检查是否正确填写了 SDKAPPID');
        } else {
          window.$message.error(imError.message);
        }
      });
    },
    logout: function logout(context) {
      if (!context.rootState.chatUser.isLogin) return; // 若有当前会话，在退出登录时已读上报

      if (context.rootState.conversation.currentConversation.conversationID) {
        tim.setMessageRead({
          conversationID: context.rootState.conversation.currentConversation.conversationID
        });
      }

      return tim.logout().then(function () {
        context.commit('toggleIsLogin'); // 清除定时器

        context.dispatch('stopComputeCurrent');
        context.commit('conversation/reset', null, {
          root: true
        });
        context.commit('reset');
      });
    },
    stopComputeCurrent: function stopComputeCurrent(state) {
      clearInterval(state.intervalID);
      state.intervalID = 0;
    }
  }
};
export default user;